export const SITE_URL = process.env.REACT_APP_SITE_URL || "https://www.chahaloverseas.com";
export const BUSINESS = "Chahal Overseas Immigration";
export const PHONE = "+1 (647) 575-1088";
export const PHONE_TEL = "+16475751088";
export const PHONE_2 = "+1 (437) 231-4007";
export const PHONE_2_TEL = "+14372314007";
export const EMAIL = "chahaloverseasimmigration@gmail.com";
export const ADDRESS_1 = "Unit 231, 7025 Tomken Road";
export const ADDRESS_2 = "Mississauga, ON L5S 1R6, Canada";
export const HOURS = "Monday–Friday: 9:00 AM–5:00 PM";
export const LEGAL_UPDATED = "June 2026";
export const GOOGLE_REVIEWS_URL = "https://www.google.com/search?q=chahal+overseas#lrd=0x882b39e6925c38bd:0x859fe480d8a1e2c8,1,,,,";
export const POST_CATEGORIES = ["Draw Results", "Policy Update", "Guide"];
export const MAP_EMBED = "https://www.google.com/maps?q=7025+Tomken+Road+Unit+231+Mississauga+ON+L5S+1R6&output=embed";
export const MAP_LINK = "https://www.google.com/maps/search/?api=1&query=7025+Tomken+Road+Unit+231+Mississauga+ON+L5S+1R6";

const CALENDLY = "https://calendly.com/chahaloverseasimmigration/paid-15-minute-meeting-online-or-in-person-ca-clone";

export const bookingUrl = () => {
  const d = new Date();
  return `${CALENDLY}?month=${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const whatsappUrl = (service) =>
  `https://wa.me/16475751088?text=${encodeURIComponent(
    `Hi Chahal Overseas Immigration, I found you through your website and would like information about ${service ? `${service}` : "my immigration options"}.`
  )}`;

const LICENCE_DATE = new Date(2021, 10, 23);

const completedYearsSince = (start) => {
  const now = new Date();
  const passed = now.getMonth() > start.getMonth() || (now.getMonth() === start.getMonth() && now.getDate() >= start.getDate());
  return now.getFullYear() - start.getFullYear() - (passed ? 0 : 1);
};

export const STATS = [
  { value: 1207, suffix: "+", label: "Approvals: permits, PRs & more" },
  { value: 55, suffix: "+", label: "Direct institutional partnerships" },
  { value: 61, suffix: "+", label: "B2B agent partners" },
  { value: completedYearsSince(LICENCE_DATE), suffix: "+", label: "Years helping clients" },
];

export const STATUS_OPTIONS = ["Worker", "Student", "Visitor", "Permanent Resident", "Other", "Outside Canada"];
export const CONTACT_METHODS = ["Phone", "WhatsApp", "Email"];

export const HOME_FAQS = [
  { q: "Can you guarantee an immigration approval?", a: "No. Immigration outcomes depend on individual circumstances and applicable Canadian requirements. No consultant should promise a guaranteed outcome." },
  { q: "My work permit is expiring. What should I do?", a: "Start early. The appropriate option depends on your status, eligibility and circumstances. A professional review can help identify what may apply before your permit expires." },
  { q: "Can you review a refusal?", a: "Yes. A refusal can be reviewed to understand the reasons and consider what options may be available based on the file." },
  { q: "Does the website provide individualized legal advice?", a: "Website content is general information. Individualized professional advice depends on a review of your specific circumstances and documents." },
  { q: "Do you work with clients outside Mississauga or outside Canada?", a: "Yes. Our office is in Mississauga, serving the Greater Toronto Area including Brampton, Toronto and Oakville, and consultations can also be held online for clients elsewhere in Canada or abroad." },
  { q: "What happens after I send an enquiry?", a: "Our team reviews the information you provide and contacts you by your preferred method to discuss next steps. Sending an enquiry does not create a retainer or representation relationship." },
];
